// extracted by mini-css-extract-plugin
export var columnList = "_hu-0";